import { LoadState } from "../../constants/enums";

export interface ICategoryState {
  list: ICategory[];
  totalRecords: number;
  loading: LoadState;
}

export interface IProductState {
  list: IMasterProduct[];
  totalRecords: number;
  loading: LoadState;
}

export interface IMasterCategoriesState {
  category: ICategoryState;
  product: IProductState;
}

export interface ICategory {
  category_name: string;
  category_uuid: string | null;
  status: string;
  create_ts?: string;
  insert_ts?: string;
  category_id?: string;
  description?: string;
}

export interface IMasterProduct {
  product_uuid: string | null;
  unique_id?: string;
  product_id?: string;
  create_ts?: string;
  insert_ts?: string;
  product_name: string;
  product_code_prefix: string;
  running_no: string;
  item_type: string;
  hsn_code: string;
  unit: string;
  product_type: string;
  gst: number;
  cess: string;
  cess_amount: string;
  no_itc: string;
  category_uuid: string;
  category_name: string;
  billing_company_uuid: string;
  billing_company_branch_uuid: string;
  unit_price: number;
  sell_price: string;
  sell_price_tax: string;
  purchase_price: string;
  purchase_price_tax: string;
  image: string | null;
  colour: string;
  description: string;
  status: string;
  combined_product_code: string;
  HSN_code: string;
}

export const initialCategoryState: ICategoryState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
};

export const initialProductState: IProductState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
};

export const initialMasterCategoriesState: IMasterCategoriesState = {
  category: initialCategoryState,
  product: initialProductState,
};
